import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Dettaglio Cliente ")
const _hoisted_3 = {
  key: 0,
  class: "p-grid"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-3 p-sm-2 p-md-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Codice ordine: ")
], -1)
const _hoisted_5 = { class: "p-col-9 p-sm-3 p-md-4" }
const _hoisted_6 = { class: "p-grid" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-3 p-sm-2 p-md-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome: ")
], -1)
const _hoisted_8 = { class: "p-col-9 p-sm-3 p-md-4" }
const _hoisted_9 = { class: "p-grid" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-3 p-sm-2 p-md-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Cognome: ")
], -1)
const _hoisted_11 = { class: "p-col-9 p-sm-3 p-md-4" }
const _hoisted_12 = { class: "p-grid" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-3 p-sm-2 p-md-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Ragione sociale: ")
], -1)
const _hoisted_14 = { class: "p-col-9 p-sm-3 p-md-4" }
const _hoisted_15 = { class: "p-grid" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-3 p-sm-2 p-md-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Tipo pagamento: ")
], -1)
const _hoisted_17 = { class: "p-col-9 p-sm-3 p-md-4" }
const _hoisted_18 = {
  key: 1,
  class: "p-fluid p-mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    content: _withCtx(() => [
      (_ctx.orderCode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.orderCode || '--'), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.customer.name), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.customer.surname), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.customer.business_name), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.customer.payment_type === 10 
                ? 'Anticipato' 
                : 'Posticipato'), 1)
      ]),
      (_ctx.isTMT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_FloatLabel, {
              label: _ctx.$t('entity.business_note')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Textarea, {
                  autoResize: true,
                  modelValue: _ctx.customer.business_note,
                  readonly: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}